module.exports = "<div class=\"container about-barbara\">\n\n  <mo-header title=\"barbara_minto\"></mo-header>\n\n  <main class=\"content wrapper\">\n\n    <mo-nav></mo-nav>\n\n    <section class=\"content-box\">\n      <img src=\"/assets/images/barbara_minto2.jpg\" alt=\"Barbara Minto\" class=\"barbara-image\">\n      <div class=\"barbara-about\" ng-bind-html=\"'barbara.text' | translate\"></div>\n    </section>\n    <img src=\"/assets/images/barbarasignature.png\" alt=\"Barbara Minto\" class=\"barbara-image\">\n\n  </main>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/modules/site/barbara/barbara.html
// module id = 536
// module chunks = 0